import Notifier from 'src/common/helpers/Notifier';

export default function notAuthorizedNotification() {
  return () => (
    Notifier.dispatch(null, 'You do not have access to this page!')
  );
}
